import { React, useState, useEffect, Card, Avatar, Toast, Breadcrumb, CustomTable, _formatDate, CustomModal, Select, Icon, showCustomConfirmMessage, useUser } from "../utils/commonImports";
import { Button, Alert, DatePicker } from "antd";
import { _api, apiUrl } from '../auth/Api';
import dayjs from "dayjs";

import { customStyleMd } from "../utils/common";
import axios from "axios";
import { getPageRights } from "../utils/accessPages";
import { _exportToExcel } from "../helper/ExportToExcel";

const Complaints = () => {
  const [complaints, setComplaints] = useState([]);
  const [viewModal, setViewModal] = useState({ isOpen: false, data: null });
  const [filterBtnShow, setFilterBtnShow] = useState(true);
  // Pagination
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(100);
  const [totalRecords, setTotalRecords] = useState(0);
  const { loggedInUser } = useUser();
  const userPages = loggedInUser?.roles?.[0]?.pages || [];
  const rights = getPageRights(userPages, 16);
  // Loading & validation
  const [loading, setLoading] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);
  const [showExp, setShowExp] = useState(false);
  // Filters
  const [filters, setFilters] = useState({
    name: "",
    email: "",
    phoneNo: "",
    status: "",
    complaintType: "",
    createDateFrom: null,
    createDateTo: null,
  });

  useEffect(() => {
    _getComplaints();
  }, []);

  const ComplaintType = [
    { value: "Parts", label: "Parts" },
    { value: "Service", label: "Service" },
    { value: "Others", label: "Others" },
  ];

  const _getComplaints = async (filterValues = {}, pageNo = page, numberOfRecords = pageSize) => {
    const payload = {
      complaintId: 0,
      name: filterValues.name || "",
      email: filterValues.email || "",
      phoneNo: filterValues.phoneNo || "",
      status: filterValues.status?.value || "",
      complaintType: filterValues.complaintType || "",
      createDateFrom: filterValues.createDateFrom ? dayjs(filterValues.createDateFrom).format("YYYY-MM-DD") : "",
      createDateTo: filterValues.createDateTo ? dayjs(filterValues.createDateTo).format("YYYY-MM-DD") : "",
      userId: 0,
      deviceGuid: "",
      isActive: true,
      page: {
        pageNo: pageNo,
        numberOfRecords: numberOfRecords
      }
    };

    try {
      setLoading(true);
      await _api("POST", "Complaint/GetAllComplaints", payload, (res) => {
        if (res.isSuccess) {
          setComplaints(res.data || []);
          setTotalRecords(res.totalRecords || 0);
        } else {
          setComplaints([]);
        }
        setLoading(false);
      });
    } catch (error) {
      console.error(error);
      setComplaints([]);
      setLoading(false);
      Toast.fire({ icon: "error", title: "Failed to fetch complaints" });
    }
  };

  const handleTableChange = (pagination) => {
    setPage(pagination.current);
    setPageSize(pagination.pageSize);
    _getComplaints(filters, pagination.current, pagination.pageSize);
  };

  const handleReset = () => {
    let filter = {
      name: "", email: "", phoneNo: "", status: "", complaintType: "", createDateFrom: null, createDateTo: null,
    };
    setShowExp(false);
    setFilters(filter);
    setPage(1);
    _getComplaints(filter, 1, pageSize);
  };

  const handleApply = () => {
    const { name, email, phoneNo, status, complaintType, createDateFrom, createDateTo } = filters;
    if (!name && !email && !phoneNo && !status && !complaintType && !createDateFrom && !createDateTo) {
      setShowExp(true);
      return;
    }
    _getComplaints(filters, 1, pageSize);
  };

  const handleUpdateStatus = async (complaint, status) => {
    let isYes = await showCustomConfirmMessage({ message: `Are you sure you want to change the status to ${status}?`, icon: status === "Resolved" ? 'info' : 'warning' })
    if (isYes) {
      try {
        const metadata = {
          complaintId: complaint?.complaintId || 0,
          status: status || "",
          userId: complaint?.userId || 0,
          name: complaint?.name || "",
          email: complaint?.email || "",
          phoneNumber: complaint?.phoneNumber || "",
          vehicleId: complaint?.vehicleId || 0,
          complaintType: complaint?.complaintType || "",
          complaintDescription: complaint?.complaintDescription || "",
          attachmentPath: complaint?.attachmentPath || "",
          deviceGUID: complaint?.deviceGUID || "",
          // isActive: true,
          // modifiedBy: 0 // ya loggedInUserId agar chahiye
        };

        const formData = new FormData();
        formData.append("files", null);
        formData.append("metadataJson", JSON.stringify(metadata));
        const storedToken = localStorage.getItem("x_t");
        const token = storedToken ? JSON.parse(storedToken).t : null;
        const url = `${apiUrl}Complaint/UpdateComplaint`
        const res = await axios.post(url, formData, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        });

        if (res.data?.isSuccess) {
          Toast.fire({ icon: "success", title: res?.data?.message });
          _getComplaints();
        } else {
          Toast.fire({ icon: "error", title: res?.data?.message });
        }
      } catch (err) {
        console.error(err);
        Toast.fire({ icon: "error", title: err?.message });
      }
    }
  };

  const columns = [
    {
      title: "Customer",
      dataIndex: "name",
      render: (_, record) => (
        <div className="d-flex align-items-center gap-2">
          <Avatar src={record.attachmentPath || null}>
            {record.name?.charAt(0).toUpperCase()}
          </Avatar>
          <div>{record.name}</div>
        </div>
      ),
    },
    {
      title: "Contact Info",
      dataIndex: "email",
      render: (_, record) => (
        <div>
          <div className="small">{record.phoneNumber}</div>
          <div className="text-muted small">{record.email}</div>
        </div>
      ),
    },
    { title: "Complaint Type", dataIndex: "complaintType" },
    { title: "Complaint Date", dataIndex: "createDate", render: (date) => _formatDate(date) },
    {
      title: "Status",
      dataIndex: "status",
      render: (status) => (
        <span className={`badge ${status === 'Pending' ? 'bg-warning' :
          status === 'Resolved' ? 'bg-success' : 'bg-secondary'
          }`}>
          {status}
        </span>
      ),
    },
    {
      title: "Actions", dataIndex: "actions",
      render: (_, record) => {
        if (record.status === "Pending") {
          return (
            <div className="d-flex gap-2">
              {rights && rights?.edit ? (<>
                <Button onClick={() => handleUpdateStatus(record, "Resolved")} size="small" className="btn-outline-success" icon={<Icon icon="feather:check" />} />
                <Button onClick={() => handleUpdateStatus(record, "In Progress")} size="small" className="btn-outline-warning" icon={<Icon icon="feather:loader" />} />
              </>) : (
                <Button size="small" disabled title="Action Not Allowed">Not Allowed </Button>
              )}
            </div>
          );
        }
        return <Icon icon="mdi:file-check-outline" fontSize={20} color="green" />;
      },
    },
  ];

  const xlsColumns = [
    { title: "User Id", dataIndex: "userId" },
    { title: "Customer Name", dataIndex: "name" },
    { title: "Email", dataIndex: "email" },
    { title: "Contact No", dataIndex: "phoneNumber" },
    { title: "Complaint Type", dataIndex: "complaintType" },
    { title: "Description", dataIndex: "complaintDescription" },
    { title: "Attachment", dataIndex: "attachmentPath" },
    { title: "Created On", dataIndex: "createDate" },
    { title: "Status", dataIndex: "status" },
  ]
  const handleExport = async () => {
    setBtnLoading(true);

    const payload = {
      complaintId: 0,
      name: "",
      email: "",
      phoneNo: "",
      status: "",
      userId: 0,
      deviceGuid: "",
      isActive: true,
      page: {
        pageNo: 0,
        numberOfRecords: 0
      }
    };
    try {
      await _api("POST", "Complaint/GetAllComplaints", payload, (res) => {
        if (res.isSuccess) {
          const krDateSahe = res.data.map((x) => ({
            ...x,
            createDate: _formatDate(x.createDate),
          }));

          setTimeout(() => {
            _exportToExcel({
              data: krDateSahe,
              columns: xlsColumns,
              fileName: "Customers Complaint",
            });
            setBtnLoading(false);
          }, 1500);
        } else {
          setBtnLoading(false);
        }
      });
    } catch (error) {
      console.error(error);
      setBtnLoading(false);
    }
  };

  return (
    <>
      <Breadcrumb title="Complaints" />
      {filterBtnShow && (
        <Card className="mb-3">
          <div className="p-2 bg-white">
            <div className="row g-2">
              <div className="col-md-3">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Customer Name"
                  value={filters.name}
                  onChange={(e) => setFilters({ ...filters, name: e.target.value })}
                />
              </div>
              <div className="col-md-3">
                <input
                  type="email"
                  className="form-control"
                  placeholder="Email"
                  value={filters.email}
                  onChange={(e) => setFilters({ ...filters, email: e.target.value })}
                />
              </div>
              <div className="col-md-3">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Phone No"
                  value={filters.phoneNo}
                  onChange={(e) => setFilters({ ...filters, phoneNo: e.target.value })}
                />
              </div>
              <div className="col-md-3">
                <Select
                  options={[
                    { label: "Pending", value: "Pending" },
                    { label: "In Progress", value: "In Progress" },
                    { label: "Resolved", value: "Resolved" },
                  ]}
                  value={filters.status}
                  onChange={(val) => setFilters({ ...filters, status: val })}
                  placeholder="Select Status"
                  isClearable
                  styles={customStyleMd}
                />
              </div>
              <div className="col-md-3">
                <Select
                  options={ComplaintType}
                  value={filters.complaintType ? { value: filters.complaintType, label: filters.complaintType } : null}
                  onChange={(val) => setFilters({ ...filters, complaintType: val ? val.value : "" })}
                  placeholder="Select Complaint Type"
                  isClearable
                  styles={customStyleMd}
                />
              </div>
              <div className="col-md-3">
                <DatePicker
                  format="YYYY-MM-DD"
                  value={filters.createDateFrom ? dayjs(filters.createDateFrom) : null}
                  onChange={(date) =>
                    setFilters({ ...filters, createDateFrom: date })
                  }
                  style={{ width: "100%" }}
                  disabledDate={(current) => {
                    // aaj ke baad wali date disable
                    if (current && current > dayjs().endOf("day")) return true;

                    // agar To Date select h to us se baad wali disable
                    if (filters.createDateTo) {
                      return current && current > dayjs(filters.createDateTo);
                    }
                    return false;
                  }}
                  placeholder="From Date"
                />
              </div>

              <div className="col-md-3">
                <DatePicker
                  format="YYYY-MM-DD"
                  value={filters.createDateTo ? dayjs(filters.createDateTo) : null}
                  onChange={(date) =>
                    setFilters({ ...filters, createDateTo: date })
                  }
                  style={{ width: "100%" }}
                  disabledDate={(current) => {
                    if (current && current > dayjs().endOf("day")) return true;
                    if (filters.createDateFrom) {
                      return current && current < dayjs(filters.createDateFrom);
                    }
                    return false;
                  }}
                  placeholder="To Date"
                />
              </div>
            </div>

            <div className="d-flex align-items-center justify-content-between gap-2 mt-3">
              <div className="flex-grow-1">
                {showExp && (
                  <Alert
                    showIcon
                    message="NOTE: Please fill at least one filter"
                    type="warning"
                  />
                )}
              </div>
              <div className="d-flex gap-2">
                <button className="btn btn-sm btn-outline-secondary" onClick={() => setFilterBtnShow(false)}>
                  Hide Filter
                </button>
                <button className="btn btn-sm btn-outline-secondary" onClick={handleReset}>
                  Reset Filters
                </button>
                <button className="btn btn-sm btn-primary" onClick={handleApply}>
                  Apply Filters
                </button>
              </div>
            </div>
          </div>
        </Card>
      )}

      <Card>
        <div className="d-flex justify-content-end" style={{ marginBottom: "10px" }}>
          {!filterBtnShow && (
            <button
              onClick={() => setFilterBtnShow(true)}
              className="btn btn-outline-primary-600 radius-3 d-flex align-items-center gap-2 px-14 py-6 text-sm"
              style={{ lineHeight: '1.2' }}
            >
              Filter Complaints
              <Icon icon="mdi:filter-cog-outline" className="text-md" />
            </button>
          )}
          <button
            onClick={handleExport}
            className="btn btn-outline-primary-600 radius-3 d-flex align-items-center gap-2 px-14 py-6 text-sm mb-2"
            style={{ lineHeight: '1.2' }}
            disabled={btnLoading}
          >
            {btnLoading && (
              <span
                className="spinner-border spinner-border-sm me-2"
                role="status"
                aria-hidden="true"
              ></span>
            )}
            {btnLoading ? "Exporting..." : "Export to Excel"}
            <Icon icon="mdi:microsoft-excel" className="text-md" />
          </button>
        </div>
        <CustomTable
          columns={columns}
          dataSource={complaints}
          options={{
            withActions: false,
            loading: loading,
            bordered: true,
            size: "small",
            rowKey: "complaintId",
            emptyText: "No complaints found",
            pageKey: 16
          }}
          pagination={{
            current: page,
            pageSize: pageSize,
            total: totalRecords,
            showSizeChanger: true,
            currentLength: complaints.length
          }}
          onChange={handleTableChange}
        />
      </Card>

      <CustomModal
        title="View Complaint"
        show={viewModal.isOpen}
        size="lg"
        onHide={() => setViewModal({ isOpen: false, data: null })}
      >
        {viewModal.data && (
          <div className="row g-3">
            <div className="col-md-3">
              <div className="border rounded py-2 px-3 bg-light shadow-sm h-90">
                <small className="text-muted">Complaint ID:</small>
                <div className="fw-semibold">{viewModal.data?.complaintId}</div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="border rounded py-2 px-3 bg-light shadow-sm h-90">
                <small className="text-muted">Name:</small>
                <div className="fw-semibold">{viewModal.data?.name}</div>
              </div>
            </div>
            <div className="col-md-5">
              <div className="border rounded py-2 px-3 bg-light shadow-sm h-90">
                <small className="text-muted">Email:</small>
                <div className="fw-semibold">{viewModal.data?.email}</div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="border rounded py-2 px-3 bg-light shadow-sm h-90">
                <small className="text-muted">Phone No:</small>
                <div className="fw-semibold">{viewModal.data?.phoneNumber}</div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="border rounded py-2 px-3 bg-light shadow-sm h-90">
                <small className="text-muted">Complaint Type:</small>
                <div className="fw-semibold">{viewModal.data?.complaintType}</div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="border rounded py-2 px-3 bg-light shadow-sm h-90">
                <small className="text-muted">Status:</small>
                <span className={`badge ${viewModal.data?.status === "In Progress" ? "bg-warning" :
                  viewModal.data?.status === "Resolved" ? "bg-success" : "bg-secondary"
                  }`}>
                  {viewModal.data?.status}
                </span>
              </div>
            </div>
            <div className="col-md-12">
              <div className="border rounded py-2 px-3 bg-light shadow-sm h-90">
                <small className="text-muted">Description:</small>
                <div className="fw-semibold">{viewModal.data?.complaintDescription}</div>
              </div>
            </div>
            {viewModal.data?.attachmentPath && (
              <div className="col-md-12">
                <div className="border rounded py-2 px-3 bg-light shadow-sm h-90">
                  <small className="text-muted">Attachment:</small>
                  <div>
                    <img src={viewModal.data.attachmentPath} alt="Complaint Attachment" className="img-fluid rounded" />
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
      </CustomModal>
    </>
  );
};

export default Complaints;